import React from "react";

import { Box, Modal, Container } from "@mui/material/";
import { ErrorMessage, Formik } from "formik";
import * as Yup from "yup";
import { PrimaryButton } from "./Buttons";
import InputField from "./InputField";
import { useTranslation } from "react-i18next";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: "15px",
  boxShadow: 24,
  p: 4,
  textAlign: "center",
  padding: "20px 20px",
};

const PasswordModal = ({ handleSubmit }) => {
  const { t } = useTranslation();
  const validate = Yup.object().shape({
    // password: Yup.string().required(t("required")),
  });
  return (
    <Modal
      keepMounted
      open={true}
      aria-labelledby="keep-mounted-modal-title"
      aria-describedby="keep-mounted-modal-description"
    >
      <Container maxWidth="lg">
        <Box sx={style}>
          <h2>{t("PASSWORD!")}</h2>
          <Formik
            initialValues={{ password: "" }}
            validationSchema={validate}
            onSubmit={(values, { setErrors }) => {
              handleSubmit(values, setErrors);
            }}
          >
            {(formik) => {
              return (
                <>
                  <InputField
                    fullWidth
                    variant="standard"
                    placeholder={t("password")}
                    label={t("password")}
                    name="password"
                    type="password"
                    onChange={formik.handleChange}
                    style={{ marginBottom: "20px" }}
                  />

                  <PrimaryButton
                    click={formik.handleSubmit}
                    width="100%"
                    fullWidth={true}
                    textTransform="capitalize"
                    title={t("next")}
                  />
                </>
              );
            }}
          </Formik>
        </Box>
      </Container>
    </Modal>
  );
};

export default PasswordModal;
